/**
 * Pick Your Favorites
 * Bag Selector Controller
 *
 * Responsibilities:
 * - select ½ lb, 1 lb, or 2 lb
 * - reset the current candy mix when the bag changes
 * - update the selected bag-card styling
 * - store the matching Shopify bag variant ID
 */

window.PYF = window.PYF || {};


/* =====================================================
   BAG CONFIGURATION
===================================================== */

PYF.bagOptions = {
  "pyf-bag-8": {
    id: "pyf-bag-8",
    size: "½ lb",
    maxPicks: 8,
    variantId: "48457339666677"
  },

  "pyf-bag-16": {
    id: "pyf-bag-16",
    size: "1 lb",
    maxPicks: 16,
    variantId: "48457342058741"
  },

  "pyf-bag-32": {
    id: "pyf-bag-32",
    size: "2 lb",
    maxPicks: 32,
    variantId: "48457343107317"
  }
};


/* =====================================================
   GET BAG CARDS
===================================================== */

PYF.getBagCards = function() {
  return Array.from(
    document.querySelectorAll(
      ".pyf-bag-card"
    )
  );
};


/* =====================================================
   READ BAG FROM CARD
===================================================== */

PYF.getBagFromCard = function(card) {
  if (!card) {
    return null;
  }

  const configuredBag =
    card.id &&
    PYF.bagOptions[card.id]
      ? PYF.bagOptions[card.id]
      : null;

  const maxPicks = Number(
    card.dataset.maxPicks ||
    card.dataset.picks ||
    configuredBag?.maxPicks ||
    0
  );

  const size =
    card.dataset.bagSize ||
    card.dataset.size ||
    configuredBag?.size ||
    "";

  const variantId =
    card.dataset.variantId ||
    configuredBag?.variantId ||
    null;

  if (
    !maxPicks ||
    !size ||
    !variantId
  ) {
    console.error(
      "PYF.getBagFromCard: Missing bag information.",
      {
        card: card,
        maxPicks: maxPicks,
        size: size,
        variantId: variantId
      }
    );

    return null;
  }

  return {
    id:
      card.dataset.bagId ||
      card.id ||
      configuredBag?.id ||
      `pyf-bag-${maxPicks}`,

    size: size,

    maxPicks: maxPicks,

    variantId: String(
      variantId
    )
  };
};


/* =====================================================
   UPDATE SELECTED CARD
===================================================== */

PYF.updateSelectedBagCard = function() {
  const cards =
    PYF.getBagCards();

  cards.forEach(function(card) {
    const bag =
      PYF.getBagFromCard(card);

    const isSelected =
      Boolean(
        bag &&
        PYF.state &&
        PYF.state.bag &&
        bag.id ===
          PYF.state.bag.id
      );

    card.classList.toggle(
      "selected",
      isSelected
    );

    card.classList.toggle(
      "active",
      isSelected
    );

    card.setAttribute(
      "aria-selected",
      isSelected
        ? "true"
        : "false"
    );

    card.setAttribute(
      "aria-checked",
      isSelected
        ? "true"
        : "false"
    );

    const button =
      card.querySelector(
        ".pyf-select-button"
      );

    if (button) {
      button.setAttribute(
        "aria-pressed",
        isSelected
          ? "true"
          : "false"
      );

      if (!button.dataset.defaultText) {
        button.dataset.defaultText =
          button.textContent.trim();
      }

      button.textContent =
        isSelected
          ? "Selected"
          : button.dataset.defaultText;
    }
  });
};


/* =====================================================
   SELECT BAG
===================================================== */

PYF.selectBag = function(card) {
  const bag =
    PYF.getBagFromCard(card);

  if (!bag) {
    console.error(
      "PYF.selectBag: Could not read bag information.",
      card
    );

    return;
  }

  const currentBag =
    PYF.state &&
    PYF.state.bag
      ? PYF.state.bag
      : null;

  const hadSelectedCandies =
    Boolean(
      PYF.state &&
      PYF.state.currentPicks > 0
    );

  const isDifferentBag =
    !currentBag ||
    currentBag.id !== bag.id;

  PYF.setBag({
    id: bag.id,
    size: bag.size,
    maxPicks: bag.maxPicks,
    variantId: bag.variantId
  });

  PYF.updateSelectedBagCard();

  console.log(
    "🍬 Selected bag:",
    PYF.state.bag
  );

  if (
    isDifferentBag &&
    hadSelectedCandies &&
    typeof PYF.showToast === "function"
  ) {
    PYF.showToast(
      "Bag changed",
      `Your mix was reset for the ${bag.size} bag.`
    );
  }
};


/* =====================================================
   INITIALIZE BAG SELECTOR
===================================================== */

PYF.initBagSelector = function() {
  const cards =
    PYF.getBagCards();

  if (!cards.length) {
    console.warn(
      "PYF.initBagSelector: No bag cards found."
    );

    return;
  }

  cards.forEach(function(card) {
    if (
      card.dataset.pyfBagInitialized ===
      "true"
    ) {
      return;
    }

    card.dataset.pyfBagInitialized =
      "true";

    const button =
      card.querySelector(
        ".pyf-select-button"
      );

    card.addEventListener(
      "click",
      function(event) {
        const interactiveElement =
          event.target.closest(
            "a, input, select, textarea"
          );

        if (
          interactiveElement &&
          !interactiveElement.classList.contains(
            "pyf-select-button"
          )
        ) {
          return;
        }

        event.preventDefault();

        PYF.selectBag(card);
      }
    );

    card.addEventListener(
      "keydown",
      function(event) {
        if (
          event.key !== "Enter" &&
          event.key !== " "
        ) {
          return;
        }

        event.preventDefault();

        PYF.selectBag(card);
      }
    );

    if (button) {
      button.type = "button";
    }
  });

  PYF.updateSelectedBagCard();
};


/* =====================================================
   STATE CHANGE LISTENER
===================================================== */

document.addEventListener(
  "pyf:state-changed",
  function() {
    PYF.updateSelectedBagCard();
  }
);